import style from './style.module.scss';
import Binance2Icon from '../../../public/images/partners/binance.svg';
import LearnMoreIcon from '../../../public/images/partners/learnMore.svg';

import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { PARTNERS_PARTNERSHIP_LINKS } from '@/core/constants';

const Partners = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <div className={style.main}>
      <div className={style.partners}>
        <div className={style.mainContainer}>
          <div className={style.leftBlock}>
            <div className={style.binanceTitle}>
              {t('slide5_h1')}

              <span dangerouslySetInnerHTML={{ __html: t('slide5_h1_1') }} />
            </div>

            <div dangerouslySetInnerHTML={{ __html: t('slide5_h2') }} className={style.subTitle} />
          </div>
          <div className={style.rightBlock}>
            <div className={style.about}>
              <div className={style.aboutTitle}>
                <div className={style.label}>{t('slide5_infoblock3_h1')}</div>
                <div className={style.text}>{t('slide5_infoblock3_h2')}</div>
              </div>
              <div className={style.pic}>
                <Binance2Icon />
              </div>
            </div>
            <a
              href={PARTNERS_PARTNERSHIP_LINKS[locale] || ''}
              className={style.learnMore}
              target="_blank"
            >
              {t('slide5_infoblock3_hoverbutton')}
              <LearnMoreIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
